var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          class: _vm.color ? '' : _vm.buttonClass,
          attrs: {
            "color": _vm.color || undefined,
            "dark": !!_vm.color,
            "icon": "",
            "aria-label": _vm.label,
            "disabled": _vm.disabled,
            "loading": _vm.loading
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.$emit('click', $event);
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v(_vm._s(_vm.icon))])], 1)];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.tooltip || _vm.label))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }